/**
 * Helpers
 */
import EA from './helpers/init';
import UserAgent from './helpers/userAgent';

/* body class */
UserAgent.setBodyClass();

/**
 * Methods
 */
import './methods/imageLazyLoad.js';
import './methods/videoLazyLoad.js';
import './methods/aboutSlider.js';
import './methods/customCursor.js';
import './methods/expanderControl.js';
import './methods/experiencesSlider.js';
import './methods/fadeAnim.js';
import './methods/fadeMobileAnim.js';
import './methods/gridSlider.js';
import './methods/gallerySlider.js';
import './methods/gallerySliderSmall.js';
import './methods/heroIntroAnim.js';
import './methods/heroDetailAnim.js';
import './methods/heroSequence.js';
import './methods/horizontalScroll.js';
import './methods/lightgallery.js';
import './methods/locomotiveScroll.js';
import './methods/mobileNav.js';
import './methods/processAnim.js';
import './methods/socialShare.js';
import './methods/testimonialSlider.js';
import './methods/textColorAnim.js';
import './methods/videoControl.js';

import { createApp } from 'vue';
import { defineAsyncComponent } from 'vue';

const app = createApp({
    mounted() {
        EA.loadMethods();
    }
});

/* Components */
app.component('ExampleComponent', defineAsyncComponent(() => import('../../components/ExampleComponent.vue')));

/* Add Pinia store */
// import { createPinia } from 'pinia';
// const pinia = createPinia();
// app.use(pinia);

app.mount('#app');
